import { NgModule } from '@angular/core';
import { NoPreloading, PreloadAllModules, RouterModule, Routes } from '@angular/router';

var routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'detail/:slug',
    loadChildren: () => import('./pages/detail/detail.module').then( m => m.DetailPageModule)
  },
  {
    path: 'eventlist/:post_type',
    loadChildren: () => import('./pages/eventlist/eventlist.module').then( m => m.EventlistPageModule)
  },
  {
    path: 'list/:post_type',
    loadChildren: () => import('./pages/list/list.module').then( m => m.ListPageModule)
  },
  {
    path: 'listcol/:post_type',
    loadChildren: () => import('./pages/listcol/listcol.module').then( m => m.ListcolPageModule)
  },
  {
    path: 'sliderlist/:post_type',
    loadChildren: () => import('./pages/sliderlist/sliderlist.module').then( m => m.SliderlistPageModule)
  },
  {
    path: 'mapweb/:post_type',
    loadChildren: () => import('./pages/mapweb/mapweb.module').then( m => m.MapwebPageModule)
  },
  {
    path: 'submenulist',
    loadChildren: () => import('./pages/submenulist/submenulist.module').then( m => m.SubmenulistPageModule)
  },
  {
    path: 'submenulistcol',
    loadChildren: () => import('./pages/submenulistcol/submenulistcol.module').then( m => m.SubmenulistcolPageModule)
  },
  /**
  
  {
    path: 'detailuser/:slug',
    loadChildren: () => import('./profilepages/detailuser/detailuser.module').then( m => m.DetailuserPageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./profilepages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'passwordreset',
    loadChildren: () => import('./profilepages/passwordreset/passwordreset.module').then( m => m.PasswordresetPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./profilepages/profile/profile.module').then( m => m.ProfilePageModule)
  },
  {
    path: 'signup',
    loadChildren: () => import('./profilepages/signup/signup.module').then( m => m.SignupPageModule)
  },
  {
    path: 'verifyemail',
    loadChildren: () => import('./profilepages/verifyemail/verifyemail.module').then( m => m.VerifyemailPageModule)
  },
  {
    path: 'userlist',
    loadChildren: () => import('./profilepages/userlist/userlist.module').then( m => m.UserlistPageModule)
  },
  **/
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
